function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModokemdevLogoMarkBlackFont = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4346.083,
    height: 793.701,
    viewBox: "0 0 3259.56 595.276",
    xmlSpace: "preserve",
    colorInterpolationFilters: "sRGB",
    style: {
      fill: "none",
      fillRule: "evenodd",
      fontSize: 12,
      overflow: "visible",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 -18.425)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 36.425,
    width: 558.85,
    height: 558.85,
    rx: 56.693,
    ry: 56.693,
    style: {
      fill: "#4f46e5",
      stroke: "#c7c8c8",
      strokeWidth: 0.25
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 67.2,
    y: 310.85,
    style: {
      fill: "#feffff",
      fontFamily: "Verdana",
      fontSize: "20.8333em",
      fontWeight: 700,
      letterSpacing: "-.04em"
    }
  }, "MD", /*#__PURE__*/React.createElement("tspan", {
    x: 97.59,
    dy: ".8em",
    style: {
      fill: "#f87171",
      fontSize: "1em"
    }
  }, "KV"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#c7c8c8",
      strokeWidth: 0.25
    },
    d: "M0 35.702h2472.4v559.574H0z",
    transform: "translate(577.681 -17.702)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 152.63,
    y: 405.49,
    style: {
      fill: "#000",
      fontFamily: "Verdana",
      fontSize: "25em",
      fontWeight: 700,
      letterSpacing: "-.0333333em"
    },
    transform: "translate(577.681 -17.702)"
  }, "ModokemDev"));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModokemdevLogoMarkBlackFont);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/modokemdev-logo-mark-black-font.76be498c42967bebb2c316a8732a84d1.svg";